import React from "react";
import { Modal } from "react-bootstrap";
import "./BlogOptimizeModal.css";

const BlogOptimizeModal = ({
  show,
  onHide,
  onStartOptimizing,
  onEditManually,
}) => {
  return (
    <>
      <div className={`backdrop-blur ${show ? "show" : ""}`} />
      <Modal
        show={show}
        onHide={onHide}
        centered
        className="product-story-modal"
      >
        <Modal.Body className="text-center">
          <div className="icon-containers">
            <img
              src="/blog-optimize-modal.svg"
              alt="Product Story"
              className="img-fluid"
              style={{ width: "150px !important", height: "150px !important" }}
            />
          </div>
          <h3 className="modal-title mt-4">Ready to share your insights?</h3>
          <p className="modal-description">
            Press generate to turn ideas into a captivating blog post.
          </p>

          <button className="optimize-button" onClick={onStartOptimizing}>
            Start Optimizing
          </button>

          <button className="manual-edit-button" onClick={onEditManually}>
            Edit details manually
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BlogOptimizeModal;
